import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots'
import useProjectContents from '../hooks/useProjectContents'

const DeliveryLists = () => {
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const table = useRef(null)
    const localStorageOrderKey = 'tblDeliveryListsOrder'
    const defaultOrder = [[ 1, 'asc' ]]

    const { currentUser } = useAuthentication();

    const {
        userHasProjectAccessLevel,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        isDeliveryListsLoaded,
        deliveryLists,
    } = useProjectContents();
    
    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()
    
    const columns = [
        { data: 'sent_date' },
        { data: 'title' },
        { data: 'delivered_by_user_id' },
        { data: 'delivered_to' },
        { data: 'delivery_list_status.name' }
    ]

    const tableSlots = {
        0: dateSlot,
        1: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/delivery_lists/${row.id}`),
        2: ownerSlot,
    }

    const tableHead = (
        <tr>
            <th>Sent</th>
            <th>Title</th>
            <th>Delivered by</th>
            <th>Delivered to</th>
            <th>Status</th>
        </tr>
    )
    
    const showLoading = isLoading || !isUserManagementInitialized || !isDeliveryListsLoaded
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>Deliveries</h2>

                            { project && userHasProjectAccessLevel(currentUser, project.id, 'MEMBER') &&
                              <Link to={`/portfolio/${project.id}/delivery_lists/new`} type="button" className="btn btn-mr btn-primary">New Delivery</Link>
                            }

                            { project && userHasProjectAccessLevel(currentUser,project.id, 'MEMBER') &&
                              <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                  Deliveries are a formal record of document and datapack delivery to customers, suppliers and partners. <br/>
                                  Quickly create and edit <strong>document delivery lists</strong>, and associated information, for transmittal notices and your log.
                              </div>
                            }

                            { project && !userHasProjectAccessLevel(currentUser, project.id, 'MEMBER') &&
                              <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                  Deliveries are the formal record of document and datapack delivery to customers, suppliers and partners. <br/>
                                  Select any delivery below to see which documents are included, and other document transmittal information.
                              </div>
                            }

                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="4"
                                    fetchUrl="/v0/delivery_list_statuses"
                                    localStorageKey="delivery_list-list-statuses"
                                />
                            </div>

                            { showLoading ? <Loading /> : (
                                <GncDataTable
                                    tableRef={table}
                                    data={deliveryLists}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeliveryLists
